"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynatraceLoader = void 0;
const scriptLibraryLoader_1 = require("../../../core/library/loader/scriptLibraryLoader");
const constants_1 = require("./constants");
class DynatraceLoader extends scriptLibraryLoader_1.ScriptLibraryLoader {
    constructor(dynatraceUrl) {
        super('Dynatrace', constants_1.LOAD_CONFIG);
        this.dynatraceUrl = dynatraceUrl;
    }
    getUrls() {
        return [this.dynatraceUrl];
    }
}
exports.DynatraceLoader = DynatraceLoader;
//# sourceMappingURL=index.js.map